import { Injectable, Injector } from '@angular/core';
import {
  HttpEvent, HttpInterceptor, HttpHandler, HttpRequest,
  HttpErrorResponse, HttpClient
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import {HttpStatus} from '../constants';
import {environment} from '../../../environments/environment';
import {Router} from '@angular/router';
import {mergeMap} from 'rxjs/operators';
import {AuthenticationService} from '../../services/authentication.service';

@Injectable()
export class RefreshTokenInterceptor implements HttpInterceptor {
  constructor(private injector: Injector, public router: Router) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const auth = this.injector.get(AuthenticationService);
    return next.handle(request).catch(error => {
      if (error instanceof HttpErrorResponse) {
        if (error.status === HttpStatus.Unauthorized && error.error.error === 'TOKEN_EXPIRED') {
          const http = this.injector.get(HttpClient);
          return http.post(environment.apiURL + `/api/auth/refresh_token`,
            JSON.stringify({data: auth.getAuthModel()})
          ).pipe(mergeMap(res => {
            auth.setToken(res);
            return next.handle(this.modifyRequest(request, auth.getCurrentToken()));
          }));
        } else {
          return Observable.throw(error);
        }
      }
    });
  }

  private modifyRequest(request, curentToken) {
    return request.clone({setHeaders: {'Authorization': 'Bearer ' + curentToken}});
  }

}



// WEBPACK FOOTER //
// /app/src/app/common/interceptor/refreshToken.interceptor.ts